<template>
  <div
    :class="['cover_icon','cover_icon_'+size]"
    :style="style"
    v-if="is_show"
  >{{this.cover_info.text}}</div>
</template>
<script>
//copy from admin_fe/pages/components/IconIput.vue
const Colors = {
  金色: {
    value: "0",
    bColor: "#DDAF5A"
  },
  橙色: {
    value: "1",
    bColor: "#FF5F00"
  },
  蓝色: {
    value: "2",
    bColor: "#0077FF"
  },
  绿色: {
    value: "3",
    bColor: "#07B85A"
  },
  橙红: {
    value: "4",
    bColor: "#E84440"
  },
  紫色: {
    value: "5",
    bColor: "#B362F2"
  },
  玫红: {
    value: "6",
    bColor: "#EF2589"
  }
};

let ColorsByValue = {};
for (let k in Colors) {
  const item = Colors[k];
  item.name = k;
  ColorsByValue[item.value] = item;
}

export default {
  name: "CoverIcon",
  components: {},
  props: {
    size: {
      type: String,
      default: "small"
    },
    info: {
      type: String,
      default: "" // "{"colorType":"0","text":"VIP","custom":"0"}"
    }
  },
  data() {
    return {};
  },
  computed: {
    is_show() {
      return this.cover_info.colorType && this.cover_info.text;
    },
    cover_info: function() {
      if (!this.info) {
        return {};
      }
      try {
        return JSON.parse(this.info);
      } catch (e) {
        return {};
      }
    },
    style() {
      if (this.cover_info.colorType) {
        return {
          background: `${
            ColorsByValue[this.cover_info.colorType].bColor
          } !important`
        };
      }
      return {};
    }
  }
};
</script>


<style lang="stylus" scoped>
  .cover_icon
    position relative
    color white
    background #FF5F00
    font-size bold
  .cover_icon_small
      padding .02rem .04rem
      font-size .22rem
      @media screen and (min-width: 700px)
        font-size 12PX
   .cover_icon_large
      font-size .28rem
      padding .02rem .06rem
      border-radius 0.06rem
      @media screen and (min-width: 700px)
        font-size 14PX

</style>
